// Single source of truth for the Social Media Hub "Focus City" picker
// (Brand Studio Step 2 + Step 3). The input is free-text with these as
// suggestions, so admins can still type any town / village / region.

import type { AdminRealm } from '@/lib/adminAuth';

export const ALBANIA_FOCUS_CITIES: string[] = [
  'Tirana',
  'Durrës',
  'Shkodër',
  'Vlorë',
  'Sarandë',
  'Ksamil',
  'Himarë',
  'Dhërmi',
  'Berat',
  'Gjirokastër',
  'Korçë',
  'Pogradec',
  'Elbasan',
  'Krujë',
  'Lezhë',
  'Përmet',
  'Theth',
  'Valbonë',
  'Butrint',
  'Orikum',
  'Golem',
  'Fier',
  'Kukës',
  'Voskopojë',
];

export const ROMANIA_FOCUS_CITIES: string[] = [
  'Bucharest',
  'Brașov',
  'Sibiu',
  'Cluj-Napoca',
  'Sighișoara',
  'Timișoara',
  'Iași',
  'Constanța',
  'Sinaia',
  'Bran',
  'Oradea',
  'Suceava',
  'Alba Iulia',
  'Tulcea',
  'Mamaia',
  'Maramureș',
];

/** Focus-city suggestions for the active realm (empty for non-travel realms). */
export function focusCitiesForRealm(realm: AdminRealm | string | null | undefined): string[] {
  if (realm === 'romania') return ROMANIA_FOCUS_CITIES;
  if (realm === 'albania') return ALBANIA_FOCUS_CITIES;
  return [];
}

/** Country label for the realm's focus city copy. */
export function focusCountryForRealm(realm: AdminRealm | string | null | undefined): string {
  return realm === 'romania' ? 'Romania' : 'Albania';
}
